/* eslint-disable @typescript-eslint/no-explicit-any */
export const PRODUCTS_UNREGULATED_TTL_ES = 'Productos No Regulados';
export interface IProductUnregulatedBase {
  code: string;
  name: string;
  barCode: string;
  format?: any;
}
export interface IProductUnregulated extends IProductUnregulatedBase {
  id: number;
}
export type IProductUnregulatedUpdate = Partial<IProductUnregulatedBase>;

export interface IHierarchyFormat {
  id: number;
  nombre: string;
  subFormat: string;
  cantidad: number;
  FV: boolean;
  FMV: boolean;
}
export interface ICustomizedFormat {
  id: number;
  nombre: string;
  subFormat: string;
  cantidad: number;
}

export interface IHierarchyFormatUpdate {
  id: number;
  nombre: string;
  subFormat: string;
  quantitySubFormat: number;
  FV: boolean;
  FMV: boolean;
}
export interface ICustomizedFormatUpdate {
  id: number;
  nombre: string;
  subFormat: string;
  quantitySubFormat: number;
}
